
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ModalWrapper from 'components/ModalWrapper'
import { useTranslation } from "react-i18next";
import TextArea from "components/forms/TextArea";
import SectionWrapper from "components/wrappers/SectionWrapper";
import Language from "components/Language";
import PropTypes from 'prop-types';

const AddFaq = ({ disabled, onCreate }) => {

    const { t } = useTranslation();

    const { register, handleSubmit, formState: { errors } } = useForm();

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
    }, [isOpen])

    const onSubmit = (data) => {
        onCreate(data)
        setIsOpen(false)
    }

    return (
        <>
            <button disabled={!!disabled}
                className={`capitalize shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  transition duration-150 ease-in-out 
 rounded  px-4 py-2 text-sm ${disabled ? 'bg-gray-200 text-gray-400' : 'text-white bg-blue-500 focus:ring-blue-700 hover:bg-blue-600'}`}
                onClick={() => setIsOpen(true)}>
                + {t('actions.new_faq')}
            </button>

            <ModalWrapper
                open={isOpen}
                setOpen={setIsOpen}
                title={t('actions.new_faq')}
            >
                <form className="w-[480px]  lg:w-[720px]" onSubmit={handleSubmit(onSubmit)}>

                    {/* Question */}
                    <SectionWrapper
                        title={t('form.question')}
                    >

                        <TextArea
                            id="question.french"
                            label={<Language _key="fr" showKeyOnly />}
                            placeholder={t('form.question') + t('form.in') + t('languages.fr')}
                            register={register("question.french", {
                                required: t('form.missing_field')
                            })}
                            error={errors?.question?.french}
                            className="my-2"

                        />
                        <TextArea
                            id="question.arabic"
                            label={<Language _key="ar" showKeyOnly />}
                            placeholder={t('form.question') + t('form.in') + t('languages.ar')}
                            register={register("question.arabic", {
                                required: t('form.missing_field')
                            })}
                            error={errors?.question?.arabic}
                            className="my-2"

                        />
                        <TextArea
                            id="question.english"
                            label={<Language _key="en" showKeyOnly />}
                            placeholder={t('form.question') + t('form.in') + t('languages.en')}
                            register={register("question.english", {
                                required: t('form.missing_field')
                            })}
                            error={errors?.question?.english}
                            className="my-2"

                        />
                    </SectionWrapper>


                    {/* Answer */}
                    <SectionWrapper
                        title={t('form.response')}
                    >

                        <TextArea
                            id="response.french"
                            label={<Language _key="fr" showKeyOnly />}
                            placeholder={t('form.response') + t('form.in') + t('languages.fr')}
                            register={register("response.french", {
                                required: t('form.missing_field')
                            })}
                            error={errors?.response?.french}
                            className="my-2"

                        />

                        <TextArea
                            id="response.arabic"
                            label={<Language _key="ar" showKeyOnly />}
                            placeholder={t('form.response') + t('form.in') + t('languages.ar')}
                            register={register("response.arabic", {
                                required: t('form.missing_field')
                            })}
                            error={errors?.response?.arabic}
                            className="my-2"

                        />
                        <TextArea
                            id="response.english"
                            label={<Language _key="en" showKeyOnly />}
                            placeholder={t('form.response') + t('form.in') + t('languages.en')}
                            register={register("response.english", {
                                required: t('form.missing_field')
                            })}
                            error={errors?.response?.english}
                            className="my-2"
                        />
                    </SectionWrapper>

                    {/* Actions  */}

                    <div className="justify-end flex items-center mt-8">
                        <input type='button' value={t('actions.cancel')} onClick={() => setIsOpen(false)}
                            className='font-medium  text-sm capitalize bg-gray-100 rounded  px-4 py-2  mx-2 border-1 border-gray-500  cursor-pointer hover:bg-gray-300 shadow'
                        />
                        <input
                            className='capitalize font-medium    text-white bg-blue-500 rounded  px-4 py-2  mx-2 border-1 border-blue-500 shadow-md  cursor-pointer hover:bg-blue-600'
                            type="submit" value={t('actions.create')} />
                    </div>
                </form>


            </ModalWrapper>


        </>

    );

}

export default AddFaq;

AddFaq.propTypes = {
  disabled: PropTypes.bool,
  onCreate: PropTypes.func.isRequired,
};

